module.exports = __webpack_public_path__ + "img/e4f45c42-340b-4550-8fbf-57a4d4266297.06f9204c.png";